import Nav from './nav';
import NavToggle from './nav-toggle';
import NavCollapse from './nav-collapse';
import Banner from './banner';

export default {
  Nav,
  NavToggle,
  NavCollapse,
  Banner,
};
